module.exports = __webpack_public_path__ + "static/media/cover_blog.3d69d590.png";